import React from 'react';
import {Button, ControlLabel, FormGroup, Modal} from 'react-bootstrap';
import Table from '../../../../../../components/Table';
import './styles.css'
import _ from 'lodash';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {personFullName} from "../../../../../../services/Api";
import SelectAsync from 'react-select/lib/Async';

class CongressDetailModal extends React.Component{
    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props ) {
        super(props);
        this.state = {
            addingAssistant: false,
            importAssistant: false,
            newAssistant: null,
            importFile: null

        };
        this.loadPeople = _.debounce(this.loadPeople, 250);
    }

    loadCongressAttendances = (tableState) =>{
        this.tableState = tableState;
        if(tableState.filters.name) tableState.filters['person.name']=tableState.filters.name;
        const filters = {...tableState.filters,'congress':this.props.congress.id};
        this.context.api.congressAttendances.get( tableState.page,tableState.pageSize,'@Class.congressDetail.congressDetail.get',filters );
    };

    loadPeople = ( name )=>{ return this.context.api.people.getSimple( 0, 10, undefined, {orSearch_fullname:name})
            .then( (people=[])=> people.map( (person)=>({value:person.id, label: personFullName(person) }) ) ) };

    onFormChange = ({target})=> this.setState(  { ...this.state, [target.name]:target.value} );

    addAssistant = () => this.setState({'addingAssistant':true});

    saveAssistant = () =>{
        if(!this.state.newAssistant) return this.context.notifier.error('Debes introducir una persona');
        const attendance = {"person":this.state.newAssistant.value,"congress":this.props.congress.id};
        this.context.api.congressAttendances.create( attendance, '@Class.CongressesAttendance.CongressesAttendance.create').then(this.finish);
    };

    finish = () => this.setState({addingAssistant:false});

    onHide = () => this.setState({'addingAssistant':false});

    deleteAssistant =  assistant => this.context.api.congressAttendances.delete( this.props.congressAttendances[ assistant.currentTarget.dataset.index].id);

    componentDidMount = () => this.context.api.clearProperty('congressAttendances');

    tableDefinitionAssistants =
        [
            {
                name:'',
                accessor: ( data, index )=>
                    <span>
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={(index)=>this.deleteAssistant(index)}><i className='ti-trash'/></button>
                    </span>
            }, {
            name:'Nombre',
            filterable:true,
            id:'name',
            accessor:(attender)=>{ return personFullName(attender.person) },
        }
        ];
    importingAssistants = event => {
        event.preventDefault();
        this.context.api.congressAttendances.import(this.props.congress.id, null, this.state.importFile)
            .then((res) => {
                if (res) {
                    this.setState({...this.state, importResult: res})
                    this.loadCongressAttendances(this.tableState);
                }
            })
    }

    render(){
        return (
            <div>
                <Modal
                    show={true}
                    dialogClassName="custom-dialog"
                    onHide={ this.props.onHide }
                    className='CongressDetailModal'>
                    <Modal.Header closeButton>
                        <Modal.Title>Detalle de congreso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className='tabla'>
                                <div className='fila'>
                                    <div className='columna lbl'>Nombre:</div>
                                    <div className='columna'>{this.props.congress.name}</div>
                                </div>
                                <div className='fila'>
                                    <div className='columna lbl'>Año:</div>
                                    <div className='columna'>{this.props.congress.year}</div>
                                </div>
                                <div className='fila'>
                                    <div className='columna lbl'>Asistentes:</div>
                                    <div className='columna asistencias'>

                                        <a href={this.context.api.congressAttendances.exportUrl(this.tableState ? {...this.tableState.filters, congress: this.props.congress.id} : null, 'xlsx')}>
                                            <button
                                                className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                                <span className='btn-label'>Descargar excel</span>
                                            </button>
                                        </a>
                                        <a href={this.context.api.congressAttendances.exportUrl(this.tableState ? {...this.tableState.filters, congress: this.props.congress.id} : null, 'pdf')}>
                                            <button
                                                className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                                <span className='btn-label'>Descargar PDF</span>
                                            </button>
                                        </a>
                                        <button className='btn btn-success btn-magnify pull-right'
                                                onClick={() => this.setState({importAssistant: true})}>
                                            <span className='btn-label'><i
                                                className='ti-plus'/> Importar asistentes</span>
                                        </button>
                                        <button className='btn btn-success btn-fill btn-magnify pull-right' onClick={this.addAssistant} >
                                            <span className='btn-label'>Agregar asistentes</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <Table
                                paginated
                                defaultPageSize={50}
                                rowIdAccessor={'id'}
                                totalItems={this.props.congressAttendancesMeta.totalItems}
                                loadData={this.loadCongressAttendances}
                                columns={ this.tableDefinitionAssistants }
                                data={this.props.congressAttendances}/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='danger' onClick={this.props.onHide}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={this.state.importAssistant}
                    onHide={() => this.setState({importAssistant: false, importResult: null})}
                >
                    <Modal.Header>
                        <Modal.Title>Importar Asistentes</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <label>
                                Adjunta un archivo excel con los asistentes del congreso.

                                <div className='contentImport'><a href="/formato_de_importacion_de_asistentes.xlsx"
                                                                  download>Archivo muestra</a><br/><br/><br/></div>

                                <input
                                    type="file"
                                    placeholder='Seleccionar archivo'
                                    onChange={event => this.setState({
                                        ...this.state,
                                        importFile: event.target.files[0]
                                    })}
                                />
                                {this.state.importResult &&
                                <div className='result'>
                                    Importación finalizada
                                    <br/>
                                    {
                                        !!this.state.importResult.errors.length &&
                                        <div className='errors'>
                                            {this.state.importResult.errors.map((error) => <p>{error}</p>)}

                                        </div>
                                    }
                                </div>
                                }
                            </label>
                            <button onClick={this.importingAssistants}>Importar</button>
                            <button onClick={(e)=>{e.preventDefault();this.setState({importAssistant: false, importResult: null})}}>Cerrar</button>
                        </form>
                    </Modal.Body>
                </Modal>



                {this.state.addingAssistant?
                    <Modal
                        size='sm'
                        show={true}
                        onHide={ this.onHide }>
                        <Modal.Header closeButton>
                            <Modal.Title>Añadir asistente</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                                <FormGroup>
                                    <ControlLabel>Asistente:</ControlLabel>
                                    <SelectAsync
                                        cacheOptions
                                        placeholder='Nombre del asistente'
                                        noOptionsMessage={()=>"Sin coincidencias"}
                                        loadOptions={this.loadPeople}
                                        onChange={(value)=>this.onFormChange({target:{name:"newAssistant", value}})}/>
                                </FormGroup>
                            <Button
                                bsStyle='danger'
                                onClick={this.onHide}>Cancelar</Button>
                            <Button
                                onClick={this.saveAssistant}
                                bsStyle='success'
                                className='pull-right'>Añadir</Button>
                        </Modal.Body>
                    </Modal> :null}
            </div>
        );
    }
}

const mapStateToProps = ( { api:{congressAttendances=[],congressAttendancesMeta={},people=[]},  } )=>({congressAttendances,congressAttendancesMeta,people});

export default connect(mapStateToProps)(CongressDetailModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Congresses/components/CongressDetailModal/index.jsx